import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-trial-expired',
  imports: [DialogModule, ButtonModule, DropdownModule, PaginatorModule, RouterLink],
  templateUrl: './trial-expired.component.html',
  styleUrl: './trial-expired.component.scss',
})
export class TrialExpiredComponent {
  constructor(public ref: DynamicDialogRef) {}

  onGoPremium() {
    this.ref.close();
  }
}
